// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__30gwz","description":"PatientConsentPreview_description__dKMIz"};